export { default } from './system'

import "./__content.scss"; import "./__form.scss"; import "./system.scss"
